import { render } from "./BrandFaq.vue?vue&type=template&id=c6da10e4"
import script from "./BrandFaq.vue?vue&type=script&lang=js"
export * from "./BrandFaq.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__